// src/components/Login.js
import React, { useEffect, useState } from 'react';
import "./Login.css";
import { useDispatch, useSelector } from 'react-redux';
import { login } from '../../Actions/adminActions';
import { Container } from "react-bootstrap";
import { AiOutlineUser } from "react-icons/ai";
import { Link, useNavigate } from "react-router-dom";
import LogoLight from "../../Images/logoLight.png";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import 'bootstrap/dist/css/bootstrap.min.css';
import { clearAdminAccess, loadAdminAccess, firstAllowedPage } from "../../Config/adminAccess";

const Login = () => {
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const [passwordVisility, setPasswordVisiblity] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleChange = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };
  const { loading, error, user } = useSelector((state) => state.admin);
  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(login(credentials))

  };
  useEffect(() => {
    if (!user) return;
    // Load this login's access first: a sub-admin may not have the dashboard
    clearAdminAccess();
    loadAdminAccess(true).then((access) => {
      const first = access && access.role !== "admin" ? firstAllowedPage(access) : "";
      navigate(first ? `/dashboard/${first}` : "/dashboard");
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);
  

  return (
    <>
      <Container id="logincontainer">
        <div className="loginContent">
          <div className="loginLogo">
            <img src={LogoLight} alt="Polybionic" />
          </div>
          <div className="loginContent_inner">
            <h4>Admin Login</h4>
            <p>Sign in to manage Polybionic</p>
            <form onSubmit={handleSubmit}>
            <div className="loginInputs">
              <div className="loginInput_inner">
                <input
                  type="text"
                  name='username'
                  placeholder="Username"
                  value={credentials.username}
                  onChange={handleChange}
                />
                <i>
                  <AiOutlineUser />
                </i>
              </div>
              <div className="loginInput_inner">
                <input
                  id="viewInput"
                  name='password'
                  type={passwordVisility ? "text" : "password"}
                  placeholder="Password"
                  value={credentials.password}
                  onChange={handleChange}
                />
                <i
                  onClick={() => setPasswordVisiblity(!passwordVisility)}
                  style={{ cursor: "pointer" }}
                >
                  {passwordVisility ? <FaRegEye /> : <FaRegEyeSlash />}
                </i>
              </div>
            </div>
            <div className="loginForgot_link">
              <Link to="/forget_password">Forgot password?</Link>
            </div>
            <div className="loginFooter_btn">
              <button className="btnPrimary mb-2" onClick={handleSubmit} id="viewBtn">
                Login
              </button>
            </div>
            </form>
          </div>
        </div>
      </Container>
    </>
  );
};

export default Login;
